import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Blog from '../Blog/Blog';
import { db } from "../lib/init-firebase";
import loader from "../../images/Loading_icon.gif"
import { collection, getDocs } from "firebase/firestore";

const HomeBlogs = () => {

    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const blogsRef = collection(db, "blogs");
        getDocs(blogsRef)
            .then((response) => {
                const newBlogs = response.docs.map(doc => doc.data());
                setBlogs(newBlogs);
            })
            .catch((error) => console.log(error.message));
    }, []);

    return (
        <div className="container">
            <h1 className="heading text-center pb-3 mt-5"><span style={{ borderBottom: '5px solid #02c2c2' }} className="">Some of <span style={{ color: '#02c2c2' }}>My Blogs</span></span></h1>
            <div className="row mt-5 mb-5 ml-2 mr-2">
                {
                    blogs.slice(0, 3).map(blog => <Blog blog={blog} />)
                }
            </div>
            <div className="text-center">
                <Link to="/blogs"><button className="custom-btn">More Blogs</button></Link>
            </div>
        </div>
    );
};

export default HomeBlogs;